import { FAQDataItem } from '@/utils/faq/FaqFormatter';
import { createLdJsonScript } from '@/utils/JsonLdSchema';

interface FAQSchemaProps {
  faqData: FAQDataItem[];
}

const FAQSchema = ({ faqData }: FAQSchemaProps) => {
  const schemaData = {
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return createLdJsonScript('FAQPage', schemaData);
};

export default FAQSchema;
